var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"compliant-block__row",class:_vm.classes},[_c('span',{class:{ timesheets__label: _vm.label === 'Timesheets' }},[_vm._v(_vm._s(_vm.label === 'Timesheets' ? `${_vm.label} (Coming soon)` : _vm.label))]),(_vm.isIconShown)?_c('ion-icon',{staticClass:"ion-icon",attrs:{"name":_vm.iconName}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }